import React, {Component} from 'react';
import {Form, Input} from 'semantic-ui-react';

class CodesPart extends Component {
  render() {
    const {
      handleChange,
      batteryCodeP11,
      batteryCodeP12,
      batteryCodeP21,
      batteryCodeP22,
      diagnosisCodeP1,
      diagnosisCodeP2,
      diagnosisCodeP3,
      diagnosisCodeP4,
      diagnosisCodeP5,
    } = this.props;

    return (
      <>
        <Form.Group>
          <div className='field'>
            <label>Código de Prueba de Batería</label>
          </div>
        </Form.Group>
        <Form.Group widths='four'>
          <Form.Field
            value={batteryCodeP11}
            control={Input}
            maxLength={8}
            label='1-1:'
            placeholder='1-1'
            onChange={(e, {value}) => handleChange('batteryCodeP11', value)}
          />
          <Form.Field
            value={batteryCodeP12}
            control={Input}
            maxLength={8}
            label='2:'
            placeholder='2'
            onChange={(e, {value}) => handleChange('batteryCodeP12', value)}
          />
          <Form.Field
            value={batteryCodeP21}
            control={Input}
            maxLength={8}
            label='2-1:'
            placeholder='2-1'
            onChange={(e, {value}) => handleChange('batteryCodeP21', value)}
          />
          <Form.Field
            value={batteryCodeP22}
            control={Input}
            maxLength={8}
            label='2:'
            placeholder='2'
            onChange={(e, {value}) => handleChange('batteryCodeP22', value)}
          />
        </Form.Group>
        <Form.Group>
          <div className='field'>
            <label>Código de Diagnóstico</label>
          </div>
        </Form.Group>
        <Form.Group widths='five'>
          <Form.Field
            value={diagnosisCodeP1}
            control={Input}
            label='1:'
            placeholder='1'
            onChange={(e, {value}) => handleChange('diagnosisCodeP1', value)}
          />
          <Form.Field
            value={diagnosisCodeP2}
            control={Input}
            label='2:'
            placeholder='2'
            onChange={(e, {value}) => handleChange('diagnosisCodeP2', value)}
          />
          <Form.Field
            value={diagnosisCodeP3}
            control={Input}
            label='3:'
            placeholder='3'
            onChange={(e, {value}) => handleChange('diagnosisCodeP3', value)}
          />
          <Form.Field
            value={diagnosisCodeP4}
            control={Input}
            label='4:'
            placeholder='4'
            onChange={(e, {value}) => handleChange('diagnosisCodeP4', value)}
          />
          <Form.Field
            value={diagnosisCodeP5}
            control={Input}
            label='5:'
            placeholder='5'
            onChange={(e, {value}) => handleChange('diagnosisCodeP5', value)}
          />
        </Form.Group>
      </>
    );
  }
}

export default CodesPart;
